import groupArrow from '@/assets/images/groupArrow.svg';

export const groupMoveButton = () => {
  if (window.storeeelItems.isMobile) return;
  // 呼び出し時に削除
  const existingButtons = document.querySelectorAll('.leftGroupButtonFrame, .rightGroupButtonFrame');
  existingButtons.forEach(button => button.remove());
  // 一時的なコンテナを作成
  const container = document.createElement('div');

  // 共通スタイル設定用ヘルパー
  const applyButtonStyles = (el, position) => {
    Object.assign(el.style, {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      padding: '16px',
      backgroundColor: 'rgba(255, 255, 255, 0.10)',
      borderRadius: '16px',
      position: 'absolute',
      bottom: '20px',
      cursor: 'pointer',
      [position]: '20px',
      maxWidth: '200px',
      minWidth: '200px',
    });
  };

  // テキスト用スタイル
  const applyTextStyles = el => {
    Object.assign(el.style, {
      fontWeight: '700',
      color: '#FFF',
      fontSize: '14px',
      lineHeight: '18.2px',
      whiteSpace: 'normal',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '2',
      wordWrap: 'break-word',
      flex: '1',
    });
  };

  // 画像用スタイル
  const applyImageStyles = (el, url) => {
    Object.assign(el.style, {
      width: '50px',
      height: '50px',
      borderRadius: '25px',
      backgroundImage: `url(${url})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    });
  };

  // アイコン用スタイル
  const applyIconStyles = (el, rotate = false) => {
    Object.assign(el.style, {
      width: '24px',
      height: '24px',
      ...(rotate && { transform: 'rotate(180deg)' }),
    });
  };

  // — 左ボタン —
  if (window.prevGroup) {
    const leftBtn = document.createElement('div');
    leftBtn.className = 'leftGroupButtonFrame';
    applyButtonStyles(leftBtn, 'left');

    let imgDiv;
    let srcUrl
    if (window.prevGroup.imageUrl) {
      imgDiv = document.createElement('img');
      srcUrl = window.prevGroup.imageUrl;
    } else {
      const mimeType = window.prevGroup.contents[0].mediaAsset.attachmentData.metadata.mime_type;
      srcUrl = window.prevGroup.contents[0].mediaAsset.mediaUrl
      if (mimeType.includes('video')) {
        imgDiv = document.createElement('video');
        imgDiv.muted = true;
        imgDiv.src = srcUrl + '#t=0.1';
        imgDiv.style.objectFit = 'cover';
      } else if (mimeType.includes('image')) {
        imgDiv = document.createElement('img');
      }
    }
    const icon = document.createElement('img');
    icon.src = groupArrow;
    applyIconStyles(icon);
    leftBtn.appendChild(icon);

    applyImageStyles(imgDiv, srcUrl + '#t=0.1');
    leftBtn.appendChild(imgDiv);

    const text = document.createElement('div');
    text.textContent = window.prevGroup.name || 'グループ名';
    applyTextStyles(text);
    leftBtn.appendChild(text);

    container.appendChild(leftBtn);
  }

  // — 右ボタン —
  if (window.nextGroup) {
    const rightBtn = document.createElement('div');
    rightBtn.className = 'rightGroupButtonFrame';
    applyButtonStyles(rightBtn, 'right');

    let imgDiv;
    let srcUrl
    if (window.nextGroup.imageUrl) {
      imgDiv = document.createElement('img');
      srcUrl = window.nextGroup.imageUrl;
    } else {
      const mimeType = window.nextGroup.contents[0].mediaAsset.attachmentData.metadata.mime_type;
      srcUrl = window.nextGroup.contents[0].mediaAsset.mediaUrl
      if (mimeType.includes('video')) {
        imgDiv = document.createElement('video');
        imgDiv.muted = true;
        imgDiv.src = srcUrl + '#t=0.1';
        imgDiv.style.objectFit = 'cover';
      } else if (mimeType.includes('image')) {
        imgDiv = document.createElement('img');
      }
    }
    applyImageStyles(imgDiv, srcUrl + '#t=0.1');
    rightBtn.appendChild(imgDiv);

    const text = document.createElement('div');
    text.textContent = window.nextGroup.name || 'グループ名';
    applyTextStyles(text);
    rightBtn.appendChild(text);

    const icon = document.createElement('img');
    icon.src = groupArrow;
    applyIconStyles(icon, true);
    rightBtn.appendChild(icon);

    container.appendChild(rightBtn);
  }

  // コンテナ内の HTML を文字列で返す
  return container.innerHTML;
};
